import { useRef, useLayoutEffect, useState } from 'react';
import { CircularProgress } from '@mui/material';
import { MODAL_LOADER_COLOR } from '../../utils';

const ActionButton = ({
    color = MODAL_LOADER_COLOR,
    disabled,
    onClick,
    loading,
    label,
}) => {
    const buttonRef = useRef(null);
    const [lockedWidth, setLockedWidth] = useState(null);

    useLayoutEffect(() => {
        if (!buttonRef.current) return;
        setLockedWidth(buttonRef.current.offsetWidth);
    }, [label]);

    return (
        <button
            ref={buttonRef}
            type="button"
            className="btn"
            style={{
                position: 'relative',
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
                whiteSpace: 'nowrap',
                width: lockedWidth ?? undefined,
                minWidth: lockedWidth ?? undefined,
                boxSizing: 'border-box',
                backgroundColor: color,
                borderColor: color,
                color: '#fff',
                borderRadius: 8,
                padding: '8px 20px',
                fontWeight: 600,
                fontSize: '0.8rem',
            }}
            disabled={disabled}
            onClick={onClick}
        >
            <span style={{ opacity: loading ? 0 : 1 }}>{label}</span>
            {loading && (
                <span
                    style={{
                        position: 'absolute',
                        inset: 0,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                    }}
                >
                    <CircularProgress size={14} style={{ color: '#fff' }} />
                </span>
            )}
        </button>
    );
};

export default ActionButton;
